import {connect} from 'react-redux';
import {getListActions, getListState} from '../../../../utilites/helpers/crudListHelper';
import productActions from '../../../../actions/shop/products';
import PartnerBannerLinkType from './PartnerBannerLinkType';

export default connect(
	(state) => getListState(state.shop.product),
	(dispatch) => getListActions(productActions, dispatch)
)(PartnerBannerLinkType);


// WEBPACK FOOTER //
// ./src/components/Partner/PartnerBannerForm/PartnerBannerLinkType/index.js